import { GET } from "./_config";

export const getDashboardData = async (query = "") => {
  return await GET(`/dashboard/overview?${query}`, true);
};
